export const ACCOUNT_CLOSING_FAILED =
  'There was an error closing this account. The request failed.'
export const ACCOUNT_RESTRICTION_FAILED =
  'There was an error restricting this account. The request failed.'
export const ACCOUNT_RETRIEVAL_FAILED =
  'There was an error retrieving the account. The request failed.'
export const ACCOUNT_UPDATE_FAILED =
  'There was an error updating this account. The request failed.'
export const SUCCESS_IN_24_HOURS =
  'Your request has been successfully submitted, please allow up to 24 hours for this change to take effect.'
export const TEMPORARILY_UNAVAILABLE =
  'Sorry, this service is temporarily unavailable. Please check back later.'
export const BAD_REQUEST = 'The request failed.'
export const UNAUTHORIZED = 'You are not authorized to view this page.'
